import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export class MultiTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient, private resources: { prefix: string, suffix: string }[]) {}

  getTranslation(lang: string): Observable<any> {
    return forkJoin(
      this.resources.map(config => {
        const loader = new TranslateHttpLoader(this.http, config.prefix, config.suffix);
        return loader.getTranslation(lang);
      })
    ).pipe(
      map(response => {
        return response.reduce((acc, res) => {
          return { ...acc, ...res };
        }, {});
      })
    );
  }
}